import { ClaimTransmissionStatus, ClaimTransmissionStatusType } from '../../../../api';
import { ITimelineEventStatusTagTone } from '../claim-timeline.types';

/** CLM02 monetary amount from an 837 X12 payload. Handles LF and CRLF segment terminators. */
export function parseTransmissionClmAmount(x12?: string | null): string {
    const clmMatch = (x12 || '').match(/CLM\*[^\r\n]*/);
    if (!clmMatch) {
        return '0';
    }

    const clmAmount = clmMatch[0].split('*')[2];
    return clmAmount ? parseFloat(clmAmount).toFixed(2) : '0';
}

export function transmissionStatusToTone(
    status?: ClaimTransmissionStatusType,
): ITimelineEventStatusTagTone {
    switch (status) {
        case ClaimTransmissionStatusType.SUBMITTED:
            return 'enter';
        case ClaimTransmissionStatusType.ACKNOWLEDGED:
            return 'pending';
        case ClaimTransmissionStatusType.COMPLETED:
            return 'success';
        case ClaimTransmissionStatusType.REJECTED:
        case ClaimTransmissionStatusType.DENIED:
            return 'attention';
        case ClaimTransmissionStatusType.ADJUDICATED:
        case ClaimTransmissionStatusType.FORWARDED:
            return 'accent';
        default:
            return 'neutral';
    }
}

export function formatTransmissionResponseMessage(status: ClaimTransmissionStatus): string {
    if (status.messages) {
        return status.messages;
    }

    if (status.status === ClaimTransmissionStatusType.SUBMITTED) {
        return 'Transmission submitted to clearinghouse.';
    }

    return status.status || 'Status update received.';
}
